import { gql } from '@apollo/client';

export const PAGE_SETTINGS = gql`
  query pageSettings($page: Int!, $amount: Int!, $field: String!, $sort: String!, $filters: [FilterInput!], $csv: Boolean!) {
    pageSettings(grid: { amount: $amount, page: $page, field: $field, filters: $filters, sort: $sort, csv: $csv }) {
      data {
        settingId
        settingName
        settingValue
        settingDescription
      }
      count
    }
  }
`;

export const GET_SETTING_BY_ID = gql`
  query getSettingById($id: Int!) {
    getSettingById(id: $id) {
      settingId
      settingName
      settingValue
      settingDescription
    }
  }
`;

export const UPDATE_SETTING = gql`
  mutation updateSetting($input: SettingsInput!) {
    updateSetting(input: $input) {
      settingId
      settingName
      settingValue
      settingDescription
    }
  }
`;
